/**
 * Calculate estimated reading time from word count
 *
 * @param {number} wordCount - Number of words in the content
 * @param {number} wordsPerMinute - Average reading speed (default: 200 wpm)
 * @returns {number} Estimated reading time in minutes
 */
export function calculateReadingTime(wordCount, wordsPerMinute = 200) {
  if (!wordCount || wordCount <= 0) {
    return 0
  }

  return Math.ceil(wordCount / wordsPerMinute)
}

/**
 * Format reading time into human-readable string
 *
 * @param {number} minutes - Reading time in minutes
 * @returns {string} Formatted string (e.g., "5 min read")
 */
export function formatReadingTime(minutes) {
  if (minutes <= 0) {
    return "< 1 min read"
  }

  if (minutes === 1) {
    return "1 min read"
  }

  return `${minutes} min read`
}

/**
 * Format word count into human-readable string
 *
 * @param {number} wordCount - Number of words
 * @returns {string} Formatted string (e.g., "1,234 words")
 */
export function formatWordCount(wordCount) {
  if (!wordCount || wordCount <= 0) {
    return "0 words"
  }

  return `${wordCount.toLocaleString()} word${wordCount === 1 ? "" : "s"}`
}
